'use client';

import { useFinancingContext } from '~/context/flp/FinancingContext';
import PrequalifiedContent from './PrequalifiedContent';
import Loader from '../Loader';
import MarketingContent from '../Marketing/MarketingContent';

export default function Prequalified() {
  const { creditStatus, isInitialized } = useFinancingContext();

  if (!isInitialized) {
    return <Loader />;
  }

  if (!creditStatus?.hasValidSoftPull) {
    return <MarketingContent />;
  }

  return <PrequalifiedContent />;
}
